import React, { createContext, useState } from "react";

const IsAuthenticatedContext = createContext();

const IsAuthenticatedProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <IsAuthenticatedContext.Provider
      value={{ isAuthenticated, setIsAuthenticated }}
    >
      {children}
    </IsAuthenticatedContext.Provider>
  );
};

export { IsAuthenticatedProvider, IsAuthenticatedContext };